import { getLogInAsHeaders, LogInAsHeaderNames } from '@fusion/saas-components-v3'
import type {
  Layout,
  PatchWidgetRequest,
  PostLayoutRequest,
  PostWidgetRequest,
  Widget
} from '@/types/dashboard'
import { DELETE, GET, PATCH, POST } from './helpers'

// Widgets
export const getWidgets = async function () {
  return GET<Widget[]>(
    `/widgets/blueskyDashboard`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}

export const postWidget = async function (widget: PostWidgetRequest) {
  const body = JSON.stringify({ ...widget, layoutName: 'blueskyDashboard' })
  return POST(
    `/widgets`,
    body,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}

export const patchWidget = async function (widget: PatchWidgetRequest, id: string) {
  const body = JSON.stringify(widget)
  return PATCH(
    `/widgets/${id}`,
    body,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}

export const deleteWidget = async function (id: string) {
  return DELETE(
    `/widgets/${id}`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}

// Layout
export const getLayout = async function () {
  return GET<Layout>(
    `/layouts/blueskyDashboard`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}

export const postLayout = async function (layout: PostLayoutRequest) {
  const body = JSON.stringify({ ...layout, name: 'blueskyDashboard' })
  return POST(
    `/layouts`,
    body,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.USER_ID])
    },
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST_V2
  )
}
